export class Product {
  pos: string;
  matnr: string;
  description: string;
  brandId: string;
  brandName: string;
  subbrandName: string;
  subbrandId: string;
  lineId: string;
  lineName: string;
  formatId: string;
  formatName: string;
  lastPurchasedate: Date;
  lastPurschasedateOrder: number;
  classificationOrder: string;

  constructor(oDataResult: any) {
    this.pos = oDataResult.POS;
    this.matnr = oDataResult.MATNR;
    this.description = oDataResult.DESCRIPTION;
    this.brandId = oDataResult.BRANDID;
    this.brandName = oDataResult.BRANDNAME;
    this.subbrandId = oDataResult.SUBBRANDID;
    this.subbrandName = oDataResult.SUBBRANDNAME;
    this.lineId = oDataResult.LINEID;
    this.lineName = oDataResult.LINENAME;
    this.formatId = oDataResult.FORMATID;
    this.formatName = oDataResult.FORMATNAME;
    this.lastPurchasedate = oDataResult.LASTREALPURCHASEDATE;
    this.lastPurschasedateOrder = new Date(this.lastPurchasedate).getTime();
    this.classificationOrder =
      this.brandName +
      '-' +
      this.subbrandName +
      '-' +
      this.lineName +
      '-' +
      this.formatName;
  }
}
